import { createContext, useContext, useState, ReactNode } from 'react';
import { EditorContextValue } from './types';

const EditorContext = createContext<EditorContextValue | undefined>(undefined);

export const useEditorContext = (): EditorContextValue => {
  const context = useContext(EditorContext);
  if (!context) {
    // Return default values if not within provider
    return {
      showHidden: false,
      setShowHidden: () => {},
    };
  }
  return context;
};

interface EditorProviderProps {
  children: ReactNode;
  initialShowHidden?: boolean;
}

export const EditorProvider: React.FC<EditorProviderProps> = ({
  children,
  initialShowHidden = false,
}) => {
  const [showHidden, setShowHidden] = useState(initialShowHidden);

  return (
    <EditorContext.Provider value={{ showHidden, setShowHidden }}>
      {children}
    </EditorContext.Provider>
  );
};
